import { useDispatch } from "react-redux";
import { useEffect } from "react";

import { setCompetitionDisclosureOpen } from "@chef/state-management";

export const useScrollToCompetitionInformation = ({
  scrollRef,
}: {
  scrollRef: React.RefObject<HTMLDivElement>;
}) => {
  const dispatch = useDispatch();

  const openCompetitionInformation = () => {
    dispatch(
      setCompetitionDisclosureOpen({
        open: true,
      }),
    );

    scrollRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    return () => {
      dispatch(
        setCompetitionDisclosureOpen({
          open: false,
        }),
      );
    };
  }, [dispatch]);

  return {
    openCompetitionInformation,
  };
};
